import React, { useState, useEffect } from 'react';
import styles from '../../products.module.scss';
import cx from 'classname';

import PhonePreview from '../../Preview';
import { PreviewImageDefault } from 'components/icons';
import { globalStyles } from 'styles';
import classname from 'classname';
import Radio from 'components/Form/Radio';
import SingleProduct from './SingleProduct';
import PlanProduct from './PlanProduct';
import ListIcon from '../../../../assets/images/listIcon.png';
import { formatCurrency } from 'libs';
import ToolTip from 'components/Tooltip';
import { useDispatch } from 'react-redux';
import { showToast } from 'store/actions/toast';
import { useForm } from 'react-hook-form';
import Button from 'components/button';

const StepThree = ({
  changeStep,
  data,
  setData,
  handleChanges,
  money,
  setMoney,
  amtType,
  setAmtType,
}) => {
  const dispatch = useDispatch();

  const [state, setState] = useState({});
  const [newState, setNewState] = useState([]);
  const [showMultiSelect, setShowMultiSelect] = useState(false);

  useEffect(() => {
    setState({
      ...(data.amountType === 'PLAN' &&
        money?.subFields?.length !== 0 && {
          plans: money?.subFields?.map((res) => {
            return {
              id: res.id,
              allowMultiSelect:
                res.allowMultiSelect === null ? false : res.allowMultiSelect,
              name: res.name,
              value: res.value,
              categories: res.subFields
                ? res.subFields.map((kek) => {
                    return {
                      id: kek.id,
                      name: kek.name,
                      value: kek.value,
                    };
                  })
                : [],
            };
          }),
        }),
      ...(data.amountType === 'PLAN' &&
        money?.subFields?.length === 0 && {
          plans: [
            {
              allowMultiSelect: false,
              name: '',
              value: '',
              categories: [],
            },
            {
              allowMultiSelect: false,
              name: '',
              value: '',
              categories: [],
            },
          ],
        }),
    });
  }, [money, data.amountType]);

  const addClick = () => {
    setState((prevState) => ({
      plans: [
        ...prevState.plans,
        {
          allowMultiSelect: false,
          name: '',
          value: '',
          categories: [],
        },
      ],
    }));
  };

  useEffect(() => {
    setNewState(state);
  }, [state]);

  const removeClick = (i) => {
    let plans = [...state.plans];
    plans.splice(i, 1);
    setState({ plans });
  };
  const addCategory = (i) => {
    let plans = [...state.plans];
    if (plans[i].categories) {
      plans[i].categories.push({ name: '', value: '' });
    } else {
      plans[i].categories = [{ name: '', value: '' }];
    }
    setState({ plans });
    if (state.plans && state?.plans[i]?.categories?.length === 2) {
      setShowMultiSelect(true);
    }
  };

  //to remove a category
  const deleteCategory = (i, idx) => {
    let plans = [...state.plans];
    plans[i].categories.splice(idx, 1);
    setState({ plans });
  };

  const onContinue = (values) => {
    setMoney({
      ...money,
      ...(data.amountType === 'PLAN' && {
        subFields: values?.plans?.map((item, i) => {
          return {
            ...money.subFields[i],
            allowMultiSelect:
              typeof item.allowMultiSelect === 'string'
                ? JSON.parse(item.allowMultiSelect)
                : item.allowMultiSelect,
            name: item.name,
            type: 'DROPDOWN',
            value: item.value,
            subFields: item.categories
              ? item.categories.map((kek, j) => {
                  return {
                    ...money?.subFields[i]?.subFields[j],
                    type: 'DROPDOWN',
                    name: kek.name,
                    value: kek.value,
                  };
                })
              : [],
          };
        }),
      }),
    });
    if (data.amountType) {
      if (data.amountType === 'DYNAMIC' && money.min && money.max) {
        if (Number(money.max) < Number(money.min)) {
          dispatch(
            showToast(
              'error',
              'Oops!',
              'Minimum amount cannot be greater than maximum amount',
            ),
          );
        } else if (Number(money.max) === Number(money.min)) {
          dispatch(
            showToast(
              'error',
              'Oops!',
              'Minimum and maximum amount cannot be the same value',
            ),
          );
        } else {
          changeStep(4);
          setData({ ...data });
        }
      } else {
        changeStep(4);
        setData({ ...data });
      }
    } else {
      dispatch(
        showToast('error', 'Oops!', 'You need to select an amount type'),
      );
    }
  };

  const { handleSubmit, errors, register, clearErrors, getValues } = useForm({
    defaultValues: {},
  });

  return (
    <div className={styles.chooseBody}>
      <div className={styles.magCreate}>
        <p className={styles.chooseTitle}>Edit Product Details</p>
        <div className={styles.createMsgs}>
          <p className={styles.chooseSub}>
            Create your product specifications and payment structure.
          </p>
          <div className={styles.btns}>
            {/* <Button
              text="Save as Draft"
              variant="gray"
              className={styles.draftsBtn}
            /> */}

            <Button
              text=" Continue"
              variant="primary"
              type="submit"
              className={styles.createBtn2}
              onClick={handleSubmit(onContinue)}
            />
          </div>
        </div>
      </div>

      <hr className={styles.line} />

      <div className={styles.rowCreate}>
        <div
          className={cx(
            styles.columnCreate,
            styles.leftCreate,
            styles.leftBg,
            styles.scrollStep,
          )}
        >
          <div className={globalStyles.flex}>
            <p className={styles.typeTitle}>
              What kind of product are you creating?
            </p>
            <ToolTip
              id="create-product"
              content={`This step allows you to control how the product appears on the agent’s dashboard.
              Single Product - Use this for one specific product\n
              Plan Model - Use this for subscriptions and recurring payments\n
              Duplicated Model - Use this for unlimited quantities of the same product\n
              `}
            />
          </div>

          <div className={classname(globalStyles.flex, styles.amountRadio)}>
            <div className={styles.amountRadioItem}>
              <Radio
                changed={() => {
                  setAmtType('single');
                  setData({ ...data, amountType: '', amount: '' });
                  setMoney({
                    ...money,
                    ...(data.amountType !== 'PLAN' && {
                      subFields: [],
                    }),
                    ...(data.amountType === 'DYNAMIC' && {
                      min: '',
                      max: '',
                    }),
                  });
                }}
                id="1"
                isSelected={amtType === 'single'}
                testId="radio-single"
              >
                Single product
              </Radio>
            </div>
            <div className={styles.amountRadioItem}>
              <Radio
                id="2"
                isSelected={amtType === 'plan'}
                changed={() => {
                  setAmtType('plan');
                  setData({ ...data, amountType: 'PLAN' });
                  setMoney({
                    ...money,
                    ...(data.amountType === 'DYNAMIC' && {
                      min: '',
                      max: '',
                    }),
                  });
                }}
                testId="radio-plan"
              >
                Plan model
              </Radio>
            </div>
          </div>

          {amtType === 'single' ? (
            <SingleProduct
              data={data}
              setData={setData}
              handleChange={handleChanges}
              money={money}
              setMoney={setMoney}
              errors={errors}
              register={register}
              amountType={amtType}
            />
          ) : amtType === 'plan' ? (
            <div data-testid="plan-div">
              <PlanProduct
                state={state}
                onClick={addClick}
                removeClick={(i) => removeClick(i)}
                addCategory={(i) => addCategory(i)}
                deleteCategory={(i, idx) => deleteCategory(i, idx)}
                errors={errors}
                register={register}
                clearErrors={clearErrors}
                getValues={getValues}
                setState={setState}
                showMultiSelect={showMultiSelect}
                setShowMultiSelect={setShowMultiSelect}
                setNewState={setNewState}
              />
            </div>
          ) : null}
        </div>

        <div
          className={cx(styles.columnCreate, styles.rightCreate, styles.pad)}
        >
          <p className={styles.description}>
            Here is a preview of the product you are creating
          </p>
          <PhonePreview title={data.title}>
            <div className={styles.preview1}>
              <div
                className={classname(
                  styles.verticalgroup,
                  globalStyles.pb0,
                  globalStyles.pt0,
                )}
              >
                {data.image ? (
                  <img src={data.image} className={styles.preview1image} />
                ) : (
                  <PreviewImageDefault style={{ margin: '10px 0' }} />
                )}
                <h3 className={styles.previewtitle}>{data.title}</h3>
                <p className={styles.previewdescription}>{data.description}</p>
              </div>
              {amtType === 'single' ? (
                <div className={styles.verticalgroup}>
                  <h3 className={styles.amount}>
                    {formatCurrency(Number(data.amount))}
                  </h3>
                </div>
              ) : amtType === 'plan' ? (
                <div className={styles.verticalgroup}>
                  {newState?.plans?.map((res, i) => {
                    return (
                      <div key={i}>
                        <h3 className={styles.previewtitle}>{res.name}</h3>
                        <h3 className={styles.amount}>
                          {' '}
                          {formatCurrency(Number(res.value))}
                        </h3>

                        {res.categories &&
                          res.categories.map((data, ind) => {
                            return (
                              <div key={ind}>
                                <div className={styles.previewCatTitle}>
                                  <img src={ListIcon} alt="list" />
                                  {data.name}
                                </div>
                                <span>
                                  {formatCurrency(Number(data.value))}
                                </span>
                              </div>
                            );
                          })}
                        <hr className={styles.planHr2} />
                      </div>
                    );
                  })}
                </div>
              ) : null}
              {data.amountType === 'DYNAMIC' && (
                <div>
                  <p className={styles.previewdescription}>Money Range</p>
                  {money.min && (
                    <div>
                      {' '}
                      <div className={styles.previewCatTitle}>
                        Minimum amount
                      </div>
                      <span>{formatCurrency(Number(money.min))}</span>
                    </div>
                  )}

                  {money.max && (
                    <div>
                      {' '}
                      <div className={styles.previewCatTitle}>
                        Maximum amount
                      </div>
                      <span>{formatCurrency(Number(money.max))}</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </PhonePreview>
        </div>
      </div>
    </div>
  );
};

export default StepThree;
